import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { fmtErr } from "@/lib/api";
import { toast } from "sonner";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", company: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(f);
      toast.success("Workspace created");
      nav("/app");
    } catch (err) {
      toast.error(fmtErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white text-slate-900 flex items-center justify-center p-6 font-[Inter,system-ui,sans-serif]">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <img src="/recruitsift-logo.png" alt="RecruitSift" className="h-10 w-auto"/>
        </Link>
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm" data-testid="register-form">
          <h1 className="text-2xl font-bold text-slate-900 mb-1">Create workspace</h1>
          <p className="text-sm text-slate-500 mb-6">Start screening candidates in minutes.</p>
          {["name","company","email","password"].map((k) => (
            <div key={k} className="mb-3">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{k}</label>
              <input data-testid={`register-${k}`} type={k==="password"?"password":k==="email"?"email":"text"} value={f[k]} onChange={(e)=>setF({...f,[k]:e.target.value})} required className="w-full mt-1 px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-sm"/>
            </div>
          ))}
          <button data-testid="register-submit" disabled={loading} className="mt-3 w-full py-2.5 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-semibold text-sm disabled:opacity-60">
            {loading ? "Creating…" : "Create workspace"}
          </button>
          <div className="mt-5 text-center text-sm text-slate-500">
            Have an account? <Link to="/login" className="text-blue-600 hover:text-blue-700 font-medium">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
